import { TFreightCard } from 'context/reducers/truckers.type';

// Preserve areaCodes of previous pages and increase with new areacodes of current page (without repeat)
export const concatMetaAreaCodes = (currentMeta: TFreightCard, newMeta: TFreightCard): TFreightCard => {
  if (!currentMeta) return newMeta;

  const tempCodes: number[] = [];
  const tempMeta = { ...newMeta };
  tempMeta.areaCodes = [...currentMeta.areaCodes, ...newMeta.areaCodes];

  tempMeta.areaCodes = tempMeta.areaCodes.filter((value) => {
    if (tempCodes.includes(value.areaCode)) {
      return false;
    }

    tempCodes.push(value.areaCode);
    return true;
  });

  return tempMeta;
};
